{
    "languages": [
        { "languageCode": "fa", "displayName": "Persian" },
        { "languageCode": "ga", "displayName": "Irish" },
        { "languageCode": "hy", "displayName": "Armenian" },
        { "languageCode": "ka", "displayName": "Georgian" },
        { "languageCode": "kk", "displayName": "Kazakh" },
        { "languageCode": "km", "displayName": "Khmer" },
        { "languageCode": "lo", "displayName": "Lao" },
        { "languageCode": "mk", "displayName": "Macedonian" },
        { "languageCode": "mn", "displayName": "Mongolian" },
        { "languageCode": "mt", "displayName": "Maltese" },
        { "languageCode": "my", "displayName": "Myanmar (Burmese)" },
        { "languageCode": "ne", "displayName": "Nepali" },
        { "languageCode": "ps", "displayName": "Pashto" },
        { "languageCode": "si", "displayName": "Sinhala" },
        { "languageCode": "so", "displayName": "Somali" },
        { "languageCode": "sq", "displayName": "Albanian" },
        { "languageCode": "uz", "displayName": "Uzbek" },
        { "languageCode": "zu", "displayName": "Zulu" }
    ]
}